/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

export const BANNER_IMPRESSION_EVENT = 'banner_impression';
export const BANNER_INTERACTION_EVENT = 'banner_interaction';

export const getAbsoluteClickUrl = (url = '') => {
    if (!url) {
        return '';
    }

    if (url.includes('http:') || url.includes('https:')) {
        return url;
    }

    const origin = typeof window !== 'undefined' && window.location?.origin ? window.location.origin : '';
    return `${origin}${url}`;
};

export const buildSiteWideBannerEvent = ({
    eventName,
    bannerGroup,
    bannerType,
    bannerItemName,
    clickId,
    clickText,
    clickUrl,
}) => ({
    eventName,
    eventCategory: eventName,
    eventAction: eventName,
    eventLabel: bannerItemName || eventName,
    ga_event_name: eventName,
    interaction_type: eventName,
    banner_group: bannerGroup || '',
    banner_type: bannerType || '',
    banner_item_name: bannerItemName || '',
    click_id: clickId || '',
    click_text: clickText || '',
    click_url: getAbsoluteClickUrl(clickUrl),
});
